import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

const HIDDEN_ROUTES = ["/login", "/signup", "/auth/callback"];

export default function StickyWhatsApp() {
  const { pathname } = useLocation();
  if (HIDDEN_ROUTES.includes(pathname)) return null;

  const message = encodeURIComponent("Hi Her Box, I need help with");
  const href = `https://wa.me/919266359966?text=${message}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-whatsapp"
      className="fixed bottom-5 right-5 z-40 flex items-center justify-center transition-all hover:scale-105"
      style={{
        width: 56,
        height: 56,
        borderRadius: "50%",
        background: "#0A0A0A",
        border: "1px solid #F5D565",
        boxShadow: "0 8px 24px rgba(245,213,101,0.18)",
      }}
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={24} strokeWidth={1.5} style={{ color: "#F5D565" }} />
    </a>
  );
}
